<div class="hero" [routerLink]="product.builderButton.link">
  @if (product.image.alt) {
    <img [ngClass]="{'show-before': media.isMatched(BREAKPOINTS.Standard.XSmall)}"
      [src]="product.image.src" [alt]="product.image.alt"/>
  }
  <div class="hero-content fx-layout-column fx-align--x-center fx-align--center-x"
    [ngClass]="{'no-image': !product.image.alt}">
    <div>
      <h2 [innerHTML]="product.name"></h2>
      @if (product.description) {
        <div class="description-block">
          <div [innerHtml]="product.description"></div>
          @if (!product.children && product.builderButton.link !== 'NONE') {
            <button mat-flat-button color="primary" [routerLink]="product.builderButton.link">{{product.builderButton.text}}</button>
          }
        </div>
      }
    </div>
  </div>
</div>

<mbnm-shop-detail-product-blocks [products]="product.children">
</mbnm-shop-detail-product-blocks>
